<template>
    <div class="ds-ex-row-menu">
        <button ref="trigger" type="button" class="ds-ex-icon-btn" aria-label="Ещё действия" aria-haspopup="menu" :aria-expanded="isOpen" @click.stop="toggle">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="5" cy="12" r="1.8" /><circle cx="12" cy="12" r="1.8" /><circle cx="19" cy="12" r="1.8" /></svg>
        </button>
        <!-- Меню в body: таблица с прокруткой не обрезает его и не получает собственный скролл. -->
        <Teleport to="body">
            <div v-if="isOpen" class="ds-ex-row-menu-backdrop" @click="close"></div>
            <div v-if="isOpen" class="ds-glass-menu ds-ex-row-menu-list" role="menu" :style="position" @keydown.esc.stop="close">
                <button
                    v-for="item in items"
                    :key="item.id"
                    type="button"
                    role="menuitem"
                    class="ds-glass-menu-item"
                    :class="{ 'ds-glass-menu-item-danger': item.danger }"
                    :disabled="item.disabled"
                    @click="select(item.id)"
                >
                    <span class="ds-glass-menu-item-label">{{ item.label }}</span>
                </button>
            </div>
        </Teleport>
    </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref } from 'vue'

export interface RowMenuItem {
    id: string
    label: string
    danger?: boolean
    disabled?: boolean
}

defineProps<{ items: RowMenuItem[] }>()
const emit = defineEmits<{ select: [id: string] }>()

const MENU_WIDTH = 200
const isOpen = ref(false)
const trigger = ref<HTMLButtonElement | null>(null)
const position = ref<Record<string, string>>({})

function place() {
    const rect = trigger.value?.getBoundingClientRect()
    if (!rect) return
    const below = window.innerHeight - rect.bottom > 140
    position.value = {
        left: `${Math.max(8, rect.right - MENU_WIDTH)}px`,
        ...(below ? { top: `${rect.bottom + 4}px` } : { bottom: `${window.innerHeight - rect.top + 4}px` }),
    }
}

function toggle() {
    if (isOpen.value) return close()
    place()
    isOpen.value = true
    window.addEventListener('scroll', close, true)
    window.addEventListener('resize', close)
}

function close() {
    isOpen.value = false
    window.removeEventListener('scroll', close, true)
    window.removeEventListener('resize', close)
}

function select(id: string) {
    close()
    emit('select', id)
}

onBeforeUnmount(close)
</script>
